import { ErrorResponse, TranslationResponse } from '../response';

export type TranslationAction = (locale: string) => Promise<TranslationResponse | ErrorResponse>
